import React, {Component} from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from "react-router-dom";
import { sendFriendRequest, respondTorequest, unfriendRequest, cancelfriendRequest} from "../../../actions/friendAction";
import {ToastsContainer, ToastsStore, ToastsContainerPosition} from 'react-toasts';
import iconPath from "../../../helpers/iconHelper";

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import Snackbar from '@material-ui/core/Snackbar';
import Alert from "./MuiAlert";



class SendFriendRequest extends Component {

    constructor(props) {
        super(props);
        this.state = {
          openDialog  : false,
          is_friend   : this.props.is_friend,
          friendId    : this.props.friendId,
          snackbar    : false,
          snackbarMsg : '',
          snackbarType: '' 
        };
        this.sendFriendRequest = this.sendFriendRequest.bind(this);
        this.respondtorequest  = this.respondtorequest.bind(this);
        this.handleClose       = this.handleClose.bind(this);
        this.handleClose2      = this.handleClose2.bind(this);
    }
    componentDidMount(){ 
      
    }

    UNSAFE_componentWillReceiveProps(nextProps,prevProps){
      this.setState({
        is_friend : nextProps.is_friend,
        friendId  : nextProps.friendId,
      }) 
      if(this.props.sendfriendrequest != nextProps.sendfriendrequest){
        ToastsStore.success('Friend request send');
        this.setState({
          is_friend : 'PENDING',
        }) 
      }else if(this.props.respondtorequest != nextProps.respondtorequest){
        ToastsStore.success(`Friend request ${nextProps.respondtorequest.status}`);
        this.setState({
          is_friend  :  nextProps.respondtorequest.status,
          openDialog :  false
        }) 
      }else if(this.props.unfriendrequest != nextProps.unfriendrequest){
        ToastsStore.success(`UnFriend`);
        this.setState({
          is_friend :  '0',
        }) 
      }else if(this.props.cancelfriendrequest != nextProps.cancelfriendrequest){
        ToastsStore.success('Cancel request');
        this.setState({
          is_friend :  '0',
        }) 
      }
    }
    handleClose(){
      this.setState({
        openDialog : this.state.openDialog === true ? false : true
      })
    }
    handleClose2(){
      this.setState({
        snackbar : true
      })
    }
    respondtorequest(status){
      let param = {
        sender_id : this.state.friendId,
        status    : status
      };
      this.props.respondTorequest(param);
    }
    sendFriendRequest(){
      if(this.state.is_friend == 'PENDING'){
        //cancel
        this.props.cancelfriendRequest({receiver_id : this.state.friendId});
      }else if(this.state.is_friend == 'ACCEPTED') {
        //unfriend
        this.props.unfriendRequest({friend_id : this.state.friendId});
      }else if(this.state.is_friend == 'PENDING RECEIVER'){
        //ACCECPT or DECLINE
        this.handleClose();
      }else{
        //send request
        this.props.sendFriendRequest(this.state.friendId);
      }
        
    }
    render(){
     
        return(
          
            <li style={{cursor: 'pointer'}}>
             
              <a href={void(0)} onClick={this.sendFriendRequest}>
                {(this.state.is_friend == 'ACCEPTED')  ? 
                  <img src={iconPath['FRIEND']}/>
                  :
                  ((this.state.is_friend == 'PENDING RECEIVER') || (this.state.is_friend == 'PENDING')) ? 
                  <img src={iconPath['PENDINGFRIEND']}/>
                    : <img src={iconPath['ADDFRIEND']}/>
                }
              </a>

              <Dialog
                open={this.state.openDialog}
                onClose={this.handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
              >
                <DialogActions>
                  <Button onClick={()=>this.respondtorequest('ACCEPTED')} color="primary">
                    ACCEPT
                  </Button>
                  <Button onClick={()=>this.respondtorequest('DECLINE')} color="secondary" autoFocus>
                    DECLINE
                  </Button>
                </DialogActions>
              </Dialog>
              <Snackbar 
                open={this.state.snackbar} 
                autoHideDuration={6000} 
                onClose={this.handleClose2}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'right',
                }}
              >
                <Alert onClose={this.handleClose2} severity="success">
                 Success
                </Alert>
              </Snackbar>
            </li>
        );
    }
}
const mapStateToProps = state => {
    return {
      sendfriendrequest   : state.friendrequest.friendRequest,
      respondtorequest    : state.requestrespond.requestRespond,
      unfriendrequest     : state.unfriendrequest.requestUnfriend,
      cancelfriendrequest : state.requestcancel.requestCancel,
    }
  }
  const mapDispatchToProps = dispatch => {
    return {
      sendFriendRequest   : bindActionCreators(sendFriendRequest, dispatch),
      respondTorequest    : bindActionCreators(respondTorequest, dispatch),
      unfriendRequest     : bindActionCreators(unfriendRequest, dispatch),
      cancelfriendRequest : bindActionCreators(cancelfriendRequest, dispatch),
    }
  }
  export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
  )(SendFriendRequest));